import React, { Component } from 'react';
import { Handle, Position } from '@xyflow/react';

class AnnotationNode extends Component {
  handleDoubleClick = (event) => {
    console.log('AnnotationNode double clicked:', this.props);
    // Để sự kiện lan lên ReactFlow
  };

  render() {
    const { data } = this.props;
    const nodeStyle = {
      cursor: 'pointer',
      border: `2px solid ${data.color || '#dddddd'}`,
      background: data.fill || '#fff',
      borderRadius: 8,
      padding: 8,
    };
    return (
      <div 
        className="react-flow__node-annotation"
        onDoubleClick={this.handleDoubleClick}
        style={nodeStyle}
      >
        <div className="annotation-node">
          <div className="annotation-content">
            <div className="annotation-level">{data.level}.</div>
            <div className="annotation-label">{data.label}</div>
          </div>
          {data.arrowStyle && (
            <div className="annotation-arrow" style={data.arrowStyle}>
              ⤹
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AnnotationNode; 